import styled from "@emotion/styled";
import Background from '../../../assets/background.jpg';
import {themeColor} from '../../layout/global-style';


export const LoginPageContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex-flow: row wrap;
  width: 100%;
  flex: 1 0 100%;
  background-image: url(${Background});
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: cover;
  background-attachment: fixed;
  height: ${ (props) => props.height };
  position: relative;
  background-color: ${themeColor.white};

  @media screen and (orientation: portrait) {
    overflow:auto;
    -webkit-overflow-scrolling:touch;
  }

  @media screen and (max-height: 300px) {
    overflow-y: auto;
  }

  .modal-login {

    .modal-close {
      display: none;
    }
    .modal-frame {
      border-color: ${themeColor.red};
      @media screen and (max-width: 540px) {
        padding: 30px 40px;
      }
      @media screen and (max-width: 390px) {
        padding: 20px;
      }
      > div .btn {
        width: 100%;
        max-width: 100%;
      }
    }
  }

 .btn--login-modal:hover.btn--default.btn--borders-all.btn--bottom-label .btn__bottom-right:after {
   color: ${themeColor.yellow};
 }      
`

export const LoginPageWrapper = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  display: flex;
  width: 100%;
  position: relative;
  align-items: center;
  justify-content: center;
  align-content: center;
  height: 100%;
  min-height: 100%;
  flex-flow: row wrap;
`;

export const LoginPageContent = styled.div`
  display: flex;
  flex-flow: row wrap;
  color: ${themeColor.black};
  position: relative;
  z-index: 0;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  gap: 24px;

  @media screen and (max-width: 768px){
    padding: 0px 24px;
    gap: 16px;
  }

  h1 {
    font-size: 120px;
    line-height: 120px;
    display: flex;
    align-items: center;
    text-align: center;
    text-transform: uppercase;
    margin: 0;

    @media screen and (max-width: 768px){
      font-size: 52px;
      line-height: 52px;
    }
  }

  p {
    font-size: 32px;
    line-height: 34px;
    display: flex;
    align-items: center;
    text-align: center;
    margin: 0;

    @media screen and (max-width: 768px){
      font-size: 18px;
      line-height: 28px;
    }
  }
`

export const CoverLogoContainer = styled.div`
  display: flex;
  img {
    height: 64px;
  }
  @media screen and (max-width: 768px){
    img {
      height: 44px;
    }
  }
`;

export const CoverHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 0px 24px;
  gap: 10px;
  @media screen and (max-width: 768px){
    padding: 0px 0px 8px;
    gap: unset;
  }
`;


export const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  button {
    width: 208px;
  }
  
  @media screen and (max-width: 768px){
    button {
      width: 150px;
      height: 32px;
      background-size: contain;

      &::before,
      &::after {
        height: 32px;
        background-size: contain;
      }
      &::before {
        left: -24px
      }
    }
    
  }
`;
export const ModalTitle = styled.p`
  display: flex;
  color: ${themeColor.red};
  margin-bottom: 16px;
  
  font-size: 48px;
  line-height: 52px;
  @media screen and (max-width: 768px){
    font-size: 32px;
    line-height: 34px;
  }
`;

export const ModalText = styled.p`
  display: flex;
  color: ${themeColor.black};

  margin-bottom: 32px;

  font-size: 24px;
  line-height: 30px;

  @media screen and (max-width: 768px){
    font-size: 18px;
    line-height: 28px;
  }
  
`;

export const CdprLoginButtonContainer = styled.p`
  button {
    gap: 6px !important;
  }
  
  svg {
    width: 32px;
    height: 32px;
    margin: 0 0 4px 0 !important;
    @media screen and (max-width: 540px) {
      width: 10px;
    }
  }
`;